import { GalleryComponent } from '../../../models/LessonComponent';
import { GalleryImage } from './GalleryImage';
import Grid from '@mui/material/Unstable_Grid2';
import LessonComponentService from '../../../services/LessonComponentService';
import React from 'react';
import styles from '../../../styles/Gallery.module.css';

export interface GalleryProps {
  component: GalleryComponent;
}

export const GalleryView = (props: GalleryProps) => {
  const items = props.component.content.column || [];
  const settings = props.component.settings?.gallerySettings;
  return (
    <Grid
      container
      className={styles.container}
      style={{
        gap: settings.padding
      }}
    >
      {items?.map((item, index) => (
        <Grid key={index} container direction="column" sx={{ width: '100%' }}>
          <Grid
            style={{
              aspectRatio:
                settings.shape === 'square' ? settings.aspectRatio : '1/1'
            }}
            className={styles.imageContainer}
            sx={{ width: '100%' }}
          >
            <GalleryImage item={item} shape={settings.shape} />
          </Grid>
          {item.text && (
            <Grid className={styles.imageText}>
              <span
                className={`ql-editor`}
                dangerouslySetInnerHTML={{
                  __html: LessonComponentService.getUrlWithSas(item.text)
                }}
              ></span>
            </Grid>
          )}
        </Grid>
      ))}
    </Grid>
  );
};
